module.exports = prizes => {
  const columns = [];

  [ 'first', 'second', 'third' ].forEach(key => {
    if (prizes && prizes[key]) {
      const { image, title } = prizes[key];
      const col = [];

      col.push('<mj-column>');

      if (image && image.fileLocation) {
        col.push(`<mj-image width="150px" src="${image.fileLocation}"/>`);
      }
      if (title) {
        col.push(`<mj-text line-height="26px" font-size="18px" align="center">${title}</mj-text>`);
      }

      col.push('</mj-column>');
      columns.push(col.join(''));
    }
  });

  return columns.join('');
};



// WEBPACK FOOTER //
// ./src/emails/components/leaderboardRewards.js